import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteGLPeriodRequest {
  companyId: number;
  fiscalYear: number;
}

const useDeleteGLPeriodApi = () => {
  const call = useCallback(async (params?: DeleteGLPeriodRequest) => {
    try {
      const res = await axiosInstance.post(api.deleteGLPeriod, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  }, []);

  const { isLoading, execute, status } = useAsync(call, false);

  return {
    isLoading,
    deleteGLPeriod: execute,
    deleteGLPeriodStatus: status,
  };
};

export default useDeleteGLPeriodApi;
